<template>
  <div>
    <div
      v-for="toolCategory in toolCategoryList"
      :key="toolCategory"
      class="tool-category"
      :class="{ selected: toolCategory === comparisonToolCategory }"
      @click="selectToolCategory(toolCategory)"
    >
      <span>
        {{
          toolCategory === 'All'
            ? $t('comparisonFeature.tools.categoryAll')
            : toolCategory === 'Routing tools'
            ? $t('comparisonFeature.tools.categoryRoutingTools')
            : toolCategory === 'Database'
            ? $t('comparisonFeature.tools.categoryDatabase')
            : toolCategory === 'Activity'
            ? $t('comparisonFeature.tools.categoryActivity')
            : ''
        }}
      </span>
      <span>
        <fa class="icon" icon="chevron-right"></fa>
      </span>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import TOOLS from '../../constants/tools';

export default {
  props: ['stage'],

  data() {
    return {
      tools: {},
    };
  },

  computed: {
    ...mapState(['comparisonToolCategory']),
    toolCategoryList() {
      const toolCategoryList = Object.keys(this.tools);
      return toolCategoryList;
    },
  },

  methods: {
    ...mapMutations(['updateComparisonToolCategory']),

    selectToolCategory(val) {
      if (this.stage === 0) this.$emit('onModalStageChange', 1);

      this.updateComparisonToolCategory(val);
    },
  },

  mounted() {
    this.tools = TOOLS;
  },
};
</script>

<style scoped lang="scss">
.tool-category {
  position: relative;
  margin: 0.75rem;
  height: 3rem;
  line-height: 3rem;
  background-color: white;
  color: $icon-grey;
  font-size: 1rem;
  font-weight: 600;
  padding: 0 1rem;
  border: 1px white solid;
  box-sizing: border-box;

  &:hover {
    cursor: pointer;
  }
}
.selected {
  color: $text-light-blue;
  text-decoration: underline;
  border: 1px $text-light-blue solid;
}
span:nth-child(2) {
  position: absolute;
  right: 0rem;
  height: 3rem;
  width: 3rem;
  font-weight: 600;
  font-size: 1.25rem;
  text-align: center;
}
</style>
